<template>
  <div>
    <table>
      <tr>
        <td>受取金額(税込)</td>
        <td>
          <div class="flex flex-content-center gap-10">
            <span>¥</span>
            <div class="box-input-money">
              <input
                type="text"
                ref="input"
                name="money"
                class="form-control text-right"
                v-currency="{currency: null, locale: 'ja', precision: 0, distractionFree: false, allowNegative: allowNegative}"
                v-model="displayValue"
                v-validate="validation"
                :data-vv-as="label"
                @blur="handleBlur"
                @focus="handleFocus"
                @input="handleInput"
              >
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>予想出品金額(税込)</td>
        <td class="text-right text-price font-bold text-size-20">¥ {{ expectedAmount(value) }}</td>
      </tr>
    </table>
    <span style="display: block" v-show="errors.has('money') && inputDirty" class="text-danger text-right">※{{ errors.first('money') }}</span>
  </div>
</template>
<script>
import { getValue } from 'vue-currency-input'
import Util from '@/common/utility'

export default {
  props: {
    inject: ['$validator'],
    value: {
      type: Number
    },
    validation: {
      type: String
    },
    label: {
      type: String
    },
    currentRowData: {
      type: Object
    },
    allowNegative: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      isInputActive: false,
      isValidated: false,
      displayValue: this.value,
      isFocus: false
    }
  },
  computed: {
    inputDirty () {
      return this.fields.money.dirty || this.isValidated
    }
  },
  methods: {
    validateAll () {
      this.isValidated = true
      this.$validator.validateAll()
    },
    handleInput () {
      if (parseInt(this.displayValue.replace(',', '')) !== this.value || this.isFocus) {
        this.$emit('input', {
          currentRowData: this.currentRowData,
          newMoney: getValue(this.$refs.input)
        })
      }
    },
    handleFocus () {
      this.isInputActive = true
      this.isFocus = true
    },
    handleBlur () {
      this.isInputActive = false
      this.isFocus = false
    },
    expectedAmount (offerPrice) {
      const coefficient = 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    }
  }
}
</script>
<style scoped>
.text-price {
  color: #B12704;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/InputMoney.vue